import AdminForm from "../component/AdminForm";
const CreateAdmin = () => { return (<AdminForm />) }
export default CreateAdmin;